const APIResult = {
  TIME_OUT: -1,
  FAILED: 0,
  SUCCESS: 1,
  INVALID: 5,

};

export default APIResult;
